import * as React from 'react';
import { memo } from 'react';
import MediaQuery from 'react-responsive';

import { MOBILE_MIN_WIDTH } from '../../utils';
import Toolbar from '../../Toolbar';
import { ToolbarProps } from '../../Toolbar/components/Toolbar';
import { FooterMobile, FooterMobileProps } from '@shared/ui';

interface Props {
	toolbarProps: ToolbarProps;
	footerMobileProps?: FooterMobileProps;
}

const ServicesToolbar: React.FC<Props> = memo(({ toolbarProps, footerMobileProps, children }) => {
	return (
		<>
			{children}

			<MediaQuery minWidth={MOBILE_MIN_WIDTH}>
				<Toolbar {...toolbarProps} />
			</MediaQuery>

			{footerMobileProps && (
				<MediaQuery maxWidth={MOBILE_MIN_WIDTH}>
					<FooterMobile {...footerMobileProps} />
				</MediaQuery>
			)}
		</>
	);
});

export default ServicesToolbar;
